import { c as _c } from "react/compiler-runtime";
import CalculationDivider from "@components/Calculation/CalculationDivider";
import { Down } from "@icon-park/svg";
import { formatMoney, formatPercent } from "@justhome/common";
import { Button, Icon } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import clsx from "clsx";
import { FC, useCallback, useState } from "react";
import { BudgetResult } from "./types";
interface BudgetCalculatorResultProps {
  result: BudgetResult | undefined;
}
const ResultRow: FC<any> = t0 => {
  const $ = _c(18);
  const {
    label,
    value,
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const locale = useLanguage();
  const t2 = size === "sm";
  const t3 = size === "md";
  const t4 = size === "lg";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = clsx({
      "text-body-2": t2,
      "text-body-1": t3,
      "text-h3 text-primary-800": t4
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = size === "sm";
  let t7;
  if ($[4] !== t6) {
    t7 = clsx("py-xs", {
      "text-neutral-425": t6
    });
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== label || $[7] !== t7) {
    t8 = <td className={t7}>{label}</td>;
    $[6] = label;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== locale || $[10] !== value) {
    t9 = formatMoney(value, false, locale);
    $[9] = locale;
    $[10] = value;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <td className="text-right py-xs">{t9}</td>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5 || $[16] !== t8) {
    t11 = <tr className={t5}>{t8}{t10}</tr>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
const BudgetCalculatorResult: FC<BudgetCalculatorResultProps> = t0 => {
  const $ = _c(17);
  const {
    result
  } = t0;
  const locale = useLanguage();
  const [showDetails, setShowDetails] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowDetails(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleShowDetailsClick = t1;
  const t2 = showDetails ? "rotate-180" : "rotate-0";
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="flex justify-end"><Button variant="ghost" size="md" paddingX={false} onClick={handleShowDetailsClick}>Details anzeigen{" "}<Icon icon={Down} className={t2} /></Button></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== locale || $[4] !== result || $[5] !== showDetails) {
    t4 = showDetails && result && <><table className="w-full text-body-2"><ResultRow size="md" label="Maximaler Darlehensbetrag" value={result.maxLoan} /><tr><td colSpan={2} className="py-xs"><CalculationDivider icon="Plus" primary={true} /></td></tr><ResultRow label="Eigenkapital" value={result.equity} /><tr><td colSpan={2} className="py-xs"><CalculationDivider icon="Minus" primary={true} /></td></tr><ResultRow label={`Sicherheitsabschlag für Unvorhergesehenes (${formatPercent(result.safetyCutOffPercent, locale)})`} value={result.safetyCutOff} /><ResultRow label={`Maklergebühr (${formatPercent(result.realEstateAgentFeePercent, locale)})`} value={result.realEstateAgentFee} /><ResultRow label={`Notar- und Grundbuchkosten (${formatPercent(result.notaryFeePercent, locale)})`} value={result.notaryFee} /><ResultRow label={`Grunderwerbsteuer (${formatPercent(result.propertyTransferTaxPercent, locale)})`} value={result.propertyTransferTax} /><tr><td colSpan={2} className="py-xs"><CalculationDivider icon="EqualSign" primary={true} /></td></tr></table></>;
    $[3] = locale;
    $[4] = result;
    $[5] = showDetails;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>So viel darf deine Immobilie kosten:</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = result?.maxPurchasePrice || 0;
  let t7;
  if ($[8] !== locale || $[9] !== t6) {
    t7 = formatMoney(t6, false, locale);
    $[8] = locale;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <p className="flex text-body-1 justify-between items-center">{t5}<span className="text-h3 font-book text-primary-800">{t7}</span></p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t8) {
    t9 = <>{t3}{t4}{t8}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default BudgetCalculatorResult;
function _temp(s) {
  return !s;
}